import React from 'react';

import { ProductButtonProps } from '../../../../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const PrivatePensionButton: React.FC<ProductButtonProps<'privatePension'>> = (props) => {
  return <ApplicationButton {...props} idSelector="privatePensionId" />;
};
